import { MultiSelect_Variable } from '../../_entity/variable/ui-components.js';
import { MultiSelect_Tag } from '../../_entity/tag/ui-components.js';
export const HCS_MultiSelect = {
    Variable: MultiSelect_Variable,
    Tag: MultiSelect_Tag,
};
//# sourceMappingURL=app-multis-select.js.map